/* =============================================================
   9 STRAP "Rollovers End Here" — page interactivity
   - Mini PDP state + render
   - Strap & glove card → PDP selectors
   - Pack bundle picker (mix-and-match models, sizes, colors)
   - Tier discounts (URL-injected Shopify discount codes)
   - Reviews marquee (3 rows)
   - FAQ accordion + smooth scroll
   ============================================================= */

(function(){
  'use strict';

  // ====== CONFIG ======
  // Discount tiers — these match Shopify's AUTOMATIC discounts ("2-Pack" 15%,
  // "Home Run Pack" 20%, "Team Pack" 25%), not the SAVE*PACK code-based discounts.
  // The automatic discounts apply on quantity threshold without a URL param, so
  // code is null. (SAVE2PACK/4/9PACK codes still exist in admin as redundant
  // fallback, but the auto-discount supersedes them.)
  const DISCOUNT_TIERS = {
    1: { pct: 0,  code: null },
    2: { pct: 15, code: null },
    4: { pct: 20, code: null },
    9: { pct: 25, code: null }
  };
  const STRAP_HANDLES = ['full-hide', 'lite-adult', 'pro'];
  const STRAP_LABELS  = { 'full-hide':'Full Hide', 'lite-adult':'Lite', 'pro':'Pro' };
  const PACK_OPTIONS  = [
    { n:1, tag:null },
    { n:2, tag:null },
    { n:4, tag:null },
    { n:9, tag:'Team pack' }
  ];

  // ====== UTILITIES ======
  document.querySelectorAll('a[href^="#"]').forEach(a=>{
    a.addEventListener('click', e=>{
      const id = a.getAttribute('href');
      if(id.length < 2) return;
      const t = document.querySelector(id);
      if(!t) return;
      e.preventDefault();
      t.scrollIntoView({behavior:'smooth', block:'start'});
    });
  });

  document.querySelectorAll('.faq-item').forEach(it=>{
    it.querySelector('.faq-q').addEventListener('click', ()=>it.classList.toggle('open'));
  });

  // ====== REVIEWS MARQUEE ======
  function buildCard(item){
    if(!item || !item.src){
      return `<div class="review-card" style="--ar:0.78;background:#141414"></div>`;
    }
    return `<div class="review-card" style="--ar:${item.ar}"><img src="${item.src}" alt="Customer review" loading="lazy"></div>`;
  }
  function fillRow(rowId, items){
    const el = document.getElementById(rowId);
    if(!el) return;
    const list = (items && items.length) ? items : [];
    if(list.length === 0){
      el.innerHTML = Array.from({length:12}, ()=>buildCard()).join('');
      return;
    }
    el.innerHTML = [...list, ...list].map(buildCard).join('');
  }
  fillRow('marquee-row-1', typeof REVIEWS_ROW_1 !== 'undefined' ? REVIEWS_ROW_1 : null);
  fillRow('marquee-row-2', typeof REVIEWS_ROW_2 !== 'undefined' ? REVIEWS_ROW_2 : null);
  fillRow('marquee-row-3', typeof REVIEWS_ROW_3 !== 'undefined' ? REVIEWS_ROW_3 : null);

  // ====== PDP STATE ======
  if(typeof PRODUCTS === 'undefined'){
    console.error('PRODUCTS data not loaded — PDP disabled');
    return;
  }

  const state = {
    handle: 'lite-adult',
    size: null,
    color: null,
    qty: 1,
    pack: 2,
    thumbOverride: false,
    bundle: []   // slots 1..pack-1 — { handle, size, color }
  };

  function product(){ return PRODUCTS[state.handle]; }
  function fmtPrice(n){ return '$' + Number(n).toFixed(2); }

  function findVariant(handle, size, color){
    const p = PRODUCTS[handle];
    if(!p) return null;
    return p.variants.find(v =>
      (size  == null || v.size  === size) &&
      (color == null || v.color === color)
    ) || null;
  }

  function pickDefaultOptions(handle){
    const p = PRODUCTS[handle];
    const firstAvail = p.variants.find(v => v.available) || p.variants[0];
    return { size: firstAvail.size || null, color: firstAvail.color || null };
  }

  function currentVariant(){ return findVariant(state.handle, state.size, state.color); }
  function comboAvailable(size, color){
    const v = findVariant(state.handle, size, color);
    return v ? v.available : false;
  }

  // ====== BUNDLE HELPERS ======
  // Each bundle slot: { customized:bool, handle, size, color }
  //   customized=false → slot mirrors primary at render time
  //   customized=true  → slot uses its stored values
  function ensureBundleSize(){
    const p = product();
    if(!p.isStrap || state.pack <= 1){ state.bundle = []; return; }
    const need = state.pack - 1;
    while(state.bundle.length < need){
      state.bundle.push({ customized:false, handle:null, size:null, color:null });
    }
    if(state.bundle.length > need){
      state.bundle = state.bundle.slice(0, need);
    }
  }
  function matchAllSlotsToPrimary(){
    state.bundle = state.bundle.map(()=>({ customized:false, handle:null, size:null, color:null }));
  }
  function customizeCount(){
    return state.bundle.filter(s=>s.customized).length;
  }
  function resolveSlot(s){
    return s.customized
      ? { handle:s.handle, size:s.size, color:s.color }
      : { handle:state.handle, size:state.size, color:state.color };
  }
  function bundleItems(){
    const arr = [{ slotIndex:0, handle:state.handle, size:state.size, color:state.color }];
    for(let i=0;i<state.bundle.length;i++){
      const r = resolveSlot(state.bundle[i]);
      arr.push({ slotIndex:i+1, ...r });
    }
    return arr.map(it=>{
      const v = findVariant(it.handle, it.size, it.color);
      return {
        ...it,
        variant: v,
        price: v ? Number(v.price) : 0,
        title: (PRODUCTS[it.handle].title || '').replace(/^9 STRAP\s*/i,'')
      };
    });
  }
  function activeDiscount(){
    if(!product().isStrap) return DISCOUNT_TIERS[1];
    return DISCOUNT_TIERS[state.pack] || DISCOUNT_TIERS[1];
  }
  function effectiveQty(){
    // For gloves, qty stepper. For straps, bundle handles quantity per-line.
    return product().isStrap ? 1 : state.qty;
  }
  function bundleSubtotal(){
    return bundleItems().reduce((s, i)=> s + i.price, 0);
  }
  function bundleTotal(){
    return bundleSubtotal() * (1 - activeDiscount().pct/100);
  }

  // ====== ELEMENT REFERENCES ======
  const els = {
    eyebrow:     document.getElementById('pdp-eyebrow'),
    title:       document.getElementById('pdp-title'),
    price:       document.getElementById('pdp-price'),
    priceMeta:   document.getElementById('pdp-price-meta'),
    desc:        document.getElementById('pdp-desc'),
    sizeRow:     document.getElementById('pdp-size-row'),
    sizeValues:  document.getElementById('pdp-size-values'),
    sizeSel:     document.getElementById('pdp-size-sel'),
    colorRow:    document.getElementById('pdp-color-row'),
    colorValues: document.getElementById('pdp-color-values'),
    colorSel:    document.getElementById('pdp-color-sel'),
    handRow:     document.getElementById('pdp-hand-row'),
    handSel:     document.getElementById('pdp-hand-sel'),
    handValues:  document.getElementById('pdp-hand-values'),
    packRow:     document.getElementById('pdp-pack-row'),
    packSel:     document.getElementById('pdp-pack-sel'),
    packValues:  document.getElementById('pdp-pack-values'),
    bundle:      document.getElementById('pdp-bundle'),
    bundleSel:   document.getElementById('pdp-bundle-sel'),
    bundleSlots: document.getElementById('pdp-bundle-slots'),
    bundleMatch: document.getElementById('pdp-bundle-match'),
    qtyRow:      document.getElementById('pdp-qty-row'),
    qty:         document.getElementById('pdp-qty'),
    stock:       document.getElementById('pdp-stock'),
    stockRowPack:document.getElementById('pdp-stock-row-pack'),
    stockPack:   document.getElementById('pdp-stock-pack'),
    atc:         document.getElementById('pdp-atc'),
    atcPrice:    document.getElementById('pdp-atc-price'),
    buy:         document.getElementById('pdp-buy'),
    pdpLink:     document.getElementById('pdp-pdp-link'),
    mainImg:     document.getElementById('pdp-main-img'),
    thumbs:      document.getElementById('pdp-thumbs')
  };

  // ====== RENDER ======
  function render(){
    const p = product();
    if(!p) return;
    ensureBundleSize();
    const v = currentVariant();

    // --- header ---
    els.eyebrow.textContent = p.eyebrow;
    els.title.textContent   = p.title.replace(/^9 STRAP\s*/i,'');
    els.desc.textContent    = p.desc;
    els.pdpLink.href        = p.url;

    const unitPrice = v ? Number(v.price) : Number(p.variants[0].price);
    els.price.textContent = fmtPrice(unitPrice);
    els.priceMeta.textContent =
      (p.handle.startsWith('integrated-glove')) ? 'strap included'
      : (p.handle === 'compatible-batting-glove') ? 'glove only'
      : 'per strap';

    // --- gallery ---
    const colorImg = (p.colorImages && state.color) ? p.colorImages[state.color] : null;
    const heroImg = colorImg || p.images[0] || '';
    if(!state.thumbOverride){
      els.mainImg.src = heroImg;
      els.mainImg.alt = p.title;
    }
    const thumbList = [];
    if(colorImg) thumbList.push(colorImg);
    for(const src of p.images.slice(0,6)){
      if(thumbList.indexOf(src) === -1) thumbList.push(src);
      if(thumbList.length >= 5) break;
    }
    els.thumbs.innerHTML = thumbList.map((src,i)=>{
      const isCur = (els.mainImg.src === src) || (!state.thumbOverride && i===0);
      return `<button class="pdp-thumb ${isCur?'is-active':''}" data-thumb-src="${src}"><img src="${src}" alt=""></button>`;
    }).join('');
    els.thumbs.querySelectorAll('.pdp-thumb').forEach(btn=>{
      btn.addEventListener('click', ()=>{
        els.mainImg.src = btn.dataset.thumbSrc;
        state.thumbOverride = true;
        els.thumbs.querySelectorAll('.pdp-thumb').forEach(b=>b.classList.toggle('is-active', b===btn));
      });
    });

    // --- hand toggle (integrated only) ---
    const isIntegrated = p.handle.startsWith('integrated-glove');
    els.handRow.style.display = isIntegrated ? '' : 'none';
    if(isIntegrated){
      els.handSel.textContent = p.hand === 'right' ? 'Right-Handed' : 'Left-Handed';
      els.handValues.querySelectorAll('.pdp-opt').forEach(b=>{
        b.classList.toggle('is-active', b.dataset.hand === p.hand);
      });
    }

    // --- size ---
    if(p.sizes && p.sizes.length){
      els.sizeRow.style.display = '';
      els.sizeSel.textContent = state.size || '';
      els.sizeValues.innerHTML = p.sizes.map(sz=>{
        const ok = comboAvailable(sz, state.color);
        const act = sz === state.size;
        return `<button class="pdp-opt ${act?'is-active':''} ${!ok?'is-oos':''}" data-size="${sz}">${sz}</button>`;
      }).join('');
      els.sizeValues.querySelectorAll('.pdp-opt').forEach(b=>{
        b.addEventListener('click', ()=>{
          const sz = b.dataset.size;
          if(!comboAvailable(sz, state.color)){
            const alt = p.colors.find(c => comboAvailable(sz, c));
            if(alt){ state.size = sz; state.color = alt; } else return;
          } else state.size = sz;
          render();
        });
      });
    } else els.sizeRow.style.display = 'none';

    // --- color ---
    if(p.colors && p.colors.length){
      els.colorRow.style.display = '';
      els.colorSel.textContent = (state.color || '').replace('Midnight / ','');
      els.colorValues.innerHTML = p.colors.map(c=>{
        const ok  = comboAvailable(state.size, c);
        const act = c === state.color;
        const hex = p.colorHex[c] || '#666';
        const label = c.replace('Midnight / ','');
        return `<button class="pdp-swatch ${act?'is-active':''} ${!ok?'is-oos':''}" style="background:${hex}" data-color="${c}" aria-label="${label}" title="${label}"></button>`;
      }).join('');
      els.colorValues.querySelectorAll('.pdp-swatch').forEach(b=>{
        b.addEventListener('click', ()=>{
          const c = b.dataset.color;
          if(!comboAvailable(state.size, c)){
            const alt = p.sizes.find(sz => comboAvailable(sz, c));
            if(alt){ state.size = alt; state.color = c; } else return;
          } else state.color = c;
          state.thumbOverride = false;
          render();
        });
      });
    } else els.colorRow.style.display = 'none';

    // --- pack vs qty ---
    if(p.isStrap){
      els.packRow.style.display = '';
      els.qtyRow.style.display  = 'none';
      els.stockRowPack.style.display = 'flex';
      els.packSel.textContent = `${state.pack}-pack`;
      els.packValues.innerHTML = PACK_OPTIONS.map(opt=>{
        const isAct = opt.n === state.pack;
        const sub = unitPrice * opt.n;
        const tier = DISCOUNT_TIERS[opt.n] || {pct:0};
        const tot = sub * (1 - tier.pct/100);
        const tag = opt.tag ? `<span class="pack-tag">${opt.tag}</span>` : '';
        const saveBadge = (!opt.tag && tier.pct > 0) ? `<span class="pack-save">Save ${tier.pct}%</span>` : '';
        const priceHtml = tier.pct > 0
          ? `<span class="pack-price-row"><span class="pack-price">${fmtPrice(tot)}</span><span class="pack-strike">${fmtPrice(sub)}</span></span>`
          : `<span class="pack-price-row"><span class="pack-price">${fmtPrice(sub)}</span></span>`;
        const eachLine = opt.n > 1
          ? `<span class="pack-each">${fmtPrice(unitPrice * (1 - tier.pct/100))} ea</span>`
          : `<span class="pack-each">&nbsp;</span>`;
        return `<button class="pdp-pack ${isAct?'is-active':''}" data-pack="${opt.n}">${tag||saveBadge}<span class="pack-count">${opt.n}-Pack</span>${priceHtml}${eachLine}</button>`;
      }).join('');
      els.packValues.querySelectorAll('.pdp-pack').forEach(b=>{
        b.addEventListener('click', ()=>{
          state.pack = parseInt(b.dataset.pack,10);
          // reset bundle to primary so user starts fresh after pack change
          state.bundle = [];
          render();
        });
      });
    } else {
      els.packRow.style.display = 'none';
      els.qtyRow.style.display  = 'flex';
      els.stockRowPack.style.display = 'none';
    }

    // --- bundle slots (only when pack > 1 on a strap) ---
    if(p.isStrap && state.pack > 1){
      els.bundle.style.display = '';
      els.bundleSel.textContent = `${state.pack} straps · mix & match`;
      renderBundleSlots();
      // hide bulk "match" button when nothing is customized (it'd be a no-op)
      els.bundleMatch.style.visibility = customizeCount() > 0 ? '' : 'hidden';
    } else {
      els.bundle.style.display = 'none';
    }

    // --- stock + ATC ---
    const itemsAvail = bundleItems().every(it => it.variant && it.variant.available);
    const stockMsg = `<span class="dot"></span>${itemsAvail ? 'In stock — ships in 1–2 days' : 'A selection is sold out'}`;
    els.stock.innerHTML = stockMsg;
    els.stockPack.innerHTML = stockMsg;
    els.stock.classList.toggle('oos', !itemsAvail);
    els.stockPack.classList.toggle('oos', !itemsAvail);

    els.atc.disabled = !itemsAvail;
    els.buy.disabled = !itemsAvail;
    els.atc.style.opacity = itemsAvail ? '' : '.5';
    els.buy.style.opacity = itemsAvail ? '' : '.5';
    els.atc.style.cursor = itemsAvail ? '' : 'not-allowed';
    els.buy.style.cursor = itemsAvail ? '' : 'not-allowed';

    const total = p.isStrap ? bundleTotal() : (unitPrice * state.qty);
    const atcLabel = p.isStrap
      ? (state.pack === 1 ? `Add to cart • ${fmtPrice(total)}` : `Add ${state.pack}-Pack to cart • ${fmtPrice(total)}`)
      : `Add to cart • ${fmtPrice(total)}`;
    els.atc.innerHTML = atcLabel;

    els.qty.value = state.qty;

    // sync active card highlight
    document.querySelectorAll('[data-product]').forEach(el=>{
      el.classList.toggle('is-active', el.dataset.product === state.handle);
    });
  }

  // ====== BUNDLE SLOT RENDER ======
  function renderBundleSlots(){
    const html = state.bundle.map((slot, idx)=>{
      const slotNo = idx + 2; // STRAP 2, 3, ...
      const r = resolveSlot(slot);
      const sp = PRODUCTS[r.handle];
      const sv = findVariant(r.handle, r.size, r.color);
      const price = sv ? fmtPrice(sv.price) : '—';

      // COLLAPSED view (default): one-liner + Customize button
      if(!slot.customized){
        const colorLabel = (r.color || '').replace('Midnight / ','');
        const summaryBits = [STRAP_LABELS[r.handle] || sp.title, r.size, colorLabel].filter(Boolean).join(' · ');
        return `
          <div class="bundle-slot is-collapsed" data-slot="${idx}">
            <div class="bundle-summary">
              <span class="bundle-slot-label">Strap ${slotNo}</span>
              <span class="bundle-summary-text"><span class="match-tag">matches Strap 1</span><span class="bundle-summary-detail">${summaryBits}</span></span>
            </div>
            <button class="bundle-customize" data-slot="${idx}" data-action="customize">Change <span class="arr">→</span></button>
          </div>`;
      }

      // EXPANDED view (customized): full pickers
      const modelHtml = STRAP_HANDLES.map(h=>{
        const isAct = h === r.handle;
        return `<button class="bundle-pill ${isAct?'is-active':''}" data-slot="${idx}" data-action="model" data-value="${h}">${STRAP_LABELS[h]}</button>`;
      }).join('');

      const sizeHtml = sp.sizes.map(sz=>{
        const slotComboAvail = !!findVariant(r.handle, sz, r.color)?.available;
        const isAct = sz === r.size;
        return `<button class="bundle-pill ${isAct?'is-active':''} ${!slotComboAvail?'is-oos':''}" data-slot="${idx}" data-action="size" data-value="${sz}">${sz}</button>`;
      }).join('');

      const colorHtml = sp.colors.length ? sp.colors.map(c=>{
        const slotComboAvail = !!findVariant(r.handle, r.size, c)?.available;
        const isAct = c === r.color;
        const hex = sp.colorHex[c] || '#666';
        const label = c.replace('Midnight / ','');
        return `<button class="bundle-swatch ${isAct?'is-active':''} ${!slotComboAvail?'is-oos':''}" style="background:${hex}" data-slot="${idx}" data-action="color" data-value="${c}" title="${label}" aria-label="${label}"></button>`;
      }).join('') : '<span style="font-size:11.5px;color:var(--ink-3);letter-spacing:.06em">No color options</span>';

      return `
        <div class="bundle-slot is-expanded" data-slot="${idx}">
          <div class="bundle-slot-head">
            <span class="label">Strap ${slotNo}</span>
            <div class="head-right">
              <span class="price">${price}</span>
              <button class="bundle-reset" data-slot="${idx}" data-action="reset-slot" title="Reset to match Strap 1">↺ match</button>
            </div>
          </div>
          <div class="bundle-row"><span class="lbl">Model</span>${modelHtml}</div>
          <div class="bundle-row"><span class="lbl">Size</span>${sizeHtml}</div>
          <div class="bundle-row"><span class="lbl">Color</span>${colorHtml}</div>
        </div>`;
    }).join('');
    els.bundleSlots.innerHTML = html;

    // wire slot controls
    els.bundleSlots.querySelectorAll('[data-action]').forEach(btn=>{
      btn.addEventListener('click', ()=>{
        const idx = parseInt(btn.dataset.slot, 10);
        const action = btn.dataset.action;
        const value = btn.dataset.value;
        const slot = state.bundle[idx];
        if(!slot) return;

        if(action === 'customize'){
          // expand: copy primary into slot as starting point
          slot.customized = true;
          slot.handle = state.handle;
          slot.size   = state.size;
          slot.color  = state.color;
          render();
          return;
        }
        if(action === 'reset-slot'){
          slot.customized = false;
          slot.handle = null; slot.size = null; slot.color = null;
          render();
          return;
        }

        if(action === 'model'){
          slot.handle = value;
          const def = pickDefaultOptions(value);
          const sizeStillOk  = PRODUCTS[value].sizes.includes(slot.size);
          slot.size  = sizeStillOk ? slot.size : def.size;
          const colorStillOk = PRODUCTS[value].colors.includes(slot.color);
          slot.color = colorStillOk ? slot.color : def.color;
        } else if(action === 'size'){
          const v = findVariant(slot.handle, value, slot.color);
          if(!v || !v.available){
            const alt = PRODUCTS[slot.handle].colors.find(c => findVariant(slot.handle, value, c)?.available);
            if(alt){ slot.size = value; slot.color = alt; } else return;
          } else slot.size = value;
        } else if(action === 'color'){
          const v = findVariant(slot.handle, slot.size, value);
          if(!v || !v.available){
            const alt = PRODUCTS[slot.handle].sizes.find(sz => findVariant(slot.handle, sz, value)?.available);
            if(alt){ slot.size = alt; slot.color = value; } else return;
          } else slot.color = value;
        }
        render();
      });
    });
  }

  // ====== ACTIONS ======
  function selectProduct(handle, scroll){
    if(!PRODUCTS[handle]) return;
    state.handle = handle;
    const def = pickDefaultOptions(handle);
    state.size  = def.size;
    state.color = def.color;
    state.qty   = 1;
    state.pack  = PRODUCTS[handle].isStrap ? 2 : 1;
    state.bundle = [];
    state.thumbOverride = false;
    render();
    if(scroll){
      document.getElementById('pdp').scrollIntoView({behavior:'smooth', block:'start'});
    }
  }

  function selectHand(hand){
    const p = product();
    if(!p || !p.sibling) return;
    const targetHandle = (hand === 'right')
      ? (p.handle.includes('right') ? p.handle : p.sibling)
      : (p.handle.includes('left')  ? p.handle : p.sibling);
    const prevSize = state.size, prevColor = state.color;
    state.handle = targetHandle;
    state.thumbOverride = false;
    if(!findVariant(targetHandle, prevSize, prevColor)){
      const def = pickDefaultOptions(targetHandle);
      state.size = def.size; state.color = def.color;
    }
    render();
  }

  function changeQty(step){
    state.qty = Math.max(1, Math.min(20, state.qty + step));
    render();
  }

  function buildCartUrl(checkout){
    const items = bundleItems().filter(i => i.variant && i.variant.available);
    if(items.length === 0) return '#';
    // aggregate identical variant IDs (line dedupe)
    const counts = {};
    for(const it of items){
      counts[it.variant.id] = (counts[it.variant.id] || 0) + 1;
    }
    // override count for non-straps (use qty stepper)
    if(!product().isStrap){
      const v = currentVariant();
      if(v) counts[v.id] = state.qty;
    }
    const path = Object.entries(counts).map(([id,q]) => `${id}:${q}`).join(',');
    const disc = activeDiscount();
    const params = [];
    if(disc.code) params.push(`discount=${disc.code}`);
    if(checkout)  params.push('checkout');
    return `https://9strap.com/cart/${path}${params.length ? '?' + params.join('&') : ''}`;
  }
  function addToCart(){ const u = buildCartUrl(false); if(u !== '#') window.location.href = u; }
  function buyNow(){    const u = buildCartUrl(true);  if(u !== '#') window.location.href = u; }

  // ====== EVENT WIRING ======
  document.querySelectorAll('[data-product]').forEach(el=>{
    el.addEventListener('click', e=>{
      e.preventDefault();
      selectProduct(el.dataset.product, true);
    });
  });
  els.handValues.querySelectorAll('.pdp-opt').forEach(b=>{
    b.addEventListener('click', ()=>selectHand(b.dataset.hand));
  });
  document.querySelectorAll('.pdp-qty button').forEach(b=>{
    b.addEventListener('click', ()=>changeQty(parseInt(b.dataset.step,10)));
  });
  els.bundleMatch.addEventListener('click', ()=>{ matchAllSlotsToPrimary(); render(); });
  els.atc.addEventListener('click', addToCart);
  els.buy.addEventListener('click', buyNow);

  // ====== SIZE HELP ACCORDION ======
  (function initSizeHelp(){
    const trigger = document.getElementById('size-help-trigger');
    const panel   = document.getElementById('size-help-panel');
    if(!trigger || !panel) return;
    trigger.addEventListener('click', ()=>{
      const open = !trigger.classList.contains('is-open');
      trigger.classList.toggle('is-open', open);
      panel.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      if(open){
        // give the accordion a moment to expand, then scroll the panel into view
        setTimeout(()=>panel.scrollIntoView({behavior:'smooth', block:'nearest'}), 220);
      }
    });
  })();

  // ====== RATING TICKER ======
  // 5-star customer counter — bumps +1 every 23s, caps at 66,000.
  (function initRating(){
    const el = document.getElementById('rating-count');
    if(!el) return;
    const START = 65781, MAX = 66000, INTERVAL_MS = 23000;
    let count = START;
    el.textContent = count.toLocaleString();
    setInterval(()=>{
      if(count >= MAX) return;
      count++;
      el.textContent = count.toLocaleString();
      el.classList.remove('tick');
      void el.offsetWidth; // restart the CSS animation
      el.classList.add('tick');
    }, INTERVAL_MS);
  })();

  // ====== INIT ======
  const def = pickDefaultOptions('lite-adult');
  state.size = def.size;
  state.color = def.color;
  render();

})();
